import { useContext } from 'react';
import { useLazyQuery } from '@apollo/client';
import { useQuery } from './useQuery';
import getProtectionPlanQuery from '../queries/protection-plan/getProtectionPlanQuery';
import { ExperienceContext } from '~/@thd-nucleus/experience-context';

const useProtectionPlan = ({
  protectionPlanParentId, storeId, price, ssr = false, lazy = false, skip = false
}) => {
  let sId = storeId;
  const ctx = useContext(ExperienceContext);

  if (!sId && ctx && ctx.store) {
    sId = ctx.store.storeId;
  }
  const options = {
    ssr,
    lazy,
    skip,
    errorPolicy: 'all',
    variables: {
      protectionPlanParentId,
      storeId: sId,
      price,
    }
  };
  const Query = getProtectionPlanQuery();

  if (lazy) return useLazyQuery(Query, options);

  return useQuery(Query, options);
};

export default useProtectionPlan;
